import { TextField } from "@spz/ui/components/textfield";
import { useEffect, useState } from "react";
import { useDebounce } from "../hooks/use-debounce";
interface SearchBarProps {
  onSearch: (term: string) => void;
  placeholder?: string;
  debounceTime?: number;
}
const SearchBar = ({ onSearch, placeholder, debounceTime }: SearchBarProps) => {
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedValue = useDebounce(searchTerm, debounceTime ?? 300);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  useEffect(() => {
    if (debouncedValue.trim() !== "" || debouncedValue === "") {
      onSearch(debouncedValue);
    }
  }, [debouncedValue, onSearch]);

  return (
    <TextField
      placeholder={placeholder}
      leftIcon="search"
      value={searchTerm}
      onChange={handleChange}
      className="text-gray-700"
    />
  );
};

export { SearchBar };
